module.exports = __webpack_public_path__ + "static/media/video-model.9ca5933.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/video-model.mp4
// module id = ZX+w
// module chunks = 0